import {Injectable} from '@angular/core';
import {RestService} from "./rest.service";

@Injectable({
  providedIn: 'root'
})
export class DictionaryService extends RestService {
  endpoint(): string {
    return "vcomparars";
  }

  param1(): string {
    return "nombre";
  }

  param2(): string {
    return "porcentaje";
  }

  param3(): string {
    return "";
  }
}
